module.exports = __webpack_public_path__ + "img/agreement_re.df7da6c3.png";